import {useState} from 'react'
import {
  ReadMoreContainer,
  Heading,
  MainContainer,
  HeadDescribe,
  ReactImage,
  Paragraph,
  Button,
} from './styledComponents'

const ReadMore = props => {
  const {reactHooksDescription} = props
  const [readMore, setReadMore] = useState({read: false})
  const toggleReadMoreOrLess = () => {
    setReadMore(prevReadMore => ({read: !prevReadMore.read}))
  }
  const description = readMore.read
    ? reactHooksDescription
    : reactHooksDescription.slice(0, 170)
  return (
    <ReadMoreContainer>
      <Heading>React Hooks</Heading>
      <HeadDescribe>Hooks are a new addition to React</HeadDescribe>
      <MainContainer>
        <ReactImage
          alt="react hooks"
          src="https://assets.ccbp.in/frontend/hooks/react-hooks-img.png"
        />
        <Paragraph>{description}</Paragraph>
        <Button type="button" onClick={toggleReadMoreOrLess}>
          {readMore.read ? 'Read Less' : 'Read More'}
        </Button>
      </MainContainer>
    </ReadMoreContainer>
  )
}
export default ReadMore
